import moment from 'moment'
import _ from 'lodash'

const formatter = {
  /**
   * element ui table date formatter
   * @param {Date} val
   */
  formatDate: (val) => {
    if (val === undefined || val === null || val === '') { return '' }
    return moment(val).format('YYYY/MM/DD')
  },

  /**
   * element ui table date formatter
   * @param {Date} val
   */
  formatDatetime: (val) => {
    if (val === undefined || val === null || val === '') { return '' }
    return moment(val).format('YYYY-MM-DD HH:mm:ss')
  },

  /**
   * element ui table currency formatter
   * @param {Date} val
   */
  formatCurrency: (val) => {
    if (val == undefined || val == '') return '';

    if (!(_.isNumber(val))) val
    return (+val || 0).toFixed(2).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
  },

  /**
  * element ui table chinese amount formatter
  * @param {Date} val
  */
  formatChineseAmount: (val,currency) => {
      if(val==null || val==""){
          return "未披露";
      }
      var dw = currency;
      if(currency && currency.toLowerCase()=='usd'){
        dw = "美元";
      }else if(currency && currency.toLowerCase()=="rmb"){
        dw="人民币";
      }else if(currency==null){
        dw="人民币";
      }
    if (val==null || val == undefined || val == '') return '';

    if (!(_.isNumber(val))) val;
    var arg = (+val || 0).toFixed(0);

    if (arg.toString().length >= 13) {
      const moneys = arg / 1000000000000
      const realVal = parseFloat(moneys).toFixed(2);
      return realVal + "万亿"+dw;
    } else if (arg.toString().length >= 9) {
      const moneys = arg / 100000000
      const realVal = parseFloat(moneys).toFixed(2);
      return realVal + "亿"+dw;
    } else if (arg.toString().length >= 4) {
      const moneys = arg / 10000
      const realVal = parseFloat(moneys).toFixed(2);
      return realVal + "万"+dw;
    }
    return realVal
  },

  /**
   * element ui table currency formatter
   * @param {Date} val
   */
  formatPercent: (val) => {
    if (!(_.isNumber(val))) val
    return (+val || 0).toFixed(10).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ',')) + '%'
  }
}

export default formatter



// WEBPACK FOOTER //
// ./src/common/formatter.js